import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Alert,
} from "@mui/material";

let lostFoundMock = [
  { id: 1, item: "Blue Bag", busNumber: "Shimla-005", contact: "98000-00001" },
  { id: 2, item: "Water Bottle", busNumber: "Manali-010", contact: "98000-00100" },
];

export default function LostFound() {
  const [posts, setPosts] = useState(lostFoundMock);
  const [form, setForm] = useState({ item: "", busNumber: "", contact: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    setPosts([{ ...form, id: Date.now() }, ...posts]);
    setSubmitted(true);
    setForm({ item: "", busNumber: "", contact: "" });
    setTimeout(() => setSubmitted(false), 2000);
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Typography variant="h5" gutterBottom>
        Lost & Found
      </Typography>
      <TextField
        label="Item Name"
        name="item"
        value={form.item}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Bus Number"
        name="busNumber"
        value={form.busNumber}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Your Contact"
        name="contact"
        value={form.contact}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      />
      <Button variant="contained" onClick={handleSubmit}>
        Submit
      </Button>
      {submitted && (
        <Alert sx={{ mt: 2 }} severity="success">
          Posted!
        </Alert>
      )}

      <Typography variant="h6" sx={{ mt: 4 }}>
        Recent Lost & Found Posts
      </Typography>
      <List>
        {posts.map((post) => (
          <ListItem key={post.id} sx={{ borderBottom: "1px solid #eee" }}>
            <ListItemText primary={`${post.item} in ${post.busNumber}`} secondary={`Contact: ${post.contact}`} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
